import type { Ref } from 'react';
import cx from 'classnames';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { TruncatedTooltip } from 'src/components/TruncatedTooltip';
import { useHistory } from 'src/lib/hooks/useHistory';
import { ROUTES } from 'src/routes';
// @ts-expect-error - no TypeScript definitions yet
import { NavigationBar } from 'src/views/NavigationBar';
import { ReviewerUserProfile } from 'src/views/TopNavigationBarItems/UserProfile/ReviewerUserProfile';

import styles from './ReviewerNavigationBar.module.scss';

interface ReviewerNavigationBarProps {
  className?: string;
  // The open project's name. The list of shared projects has none and no Back button.
  projectName?: string | null;
}

export const ReviewerNavigationBar = ({ className, projectName }: ReviewerNavigationBarProps) => {
  const history = useHistory();
  const isProjectPage = projectName !== undefined;

  const handleBackClick = () => {
    history.push(ROUTES.ROOT);
    return false;
  };

  return (
    <NavigationBar
      className={cx(styles.root, className)}
      displayLogo
      displayBackButton={isProjectPage}
      displayProjectName={Boolean(projectName)}
      onBackClick={handleBackClick}
    >
      <div className={styles.items}>
        {projectName && (
          <TruncatedTooltip title={projectName}>
            {(labelRef: Ref<HTMLParagraphElement>) => (
              <CustomTypography
                className={styles.projectName}
                ref={labelRef}
                variant={TYPOGRAPHY_VARIANT.medium16}
              >
                {projectName}
              </CustomTypography>
            )}
          </TruncatedTooltip>
        )}

        <ReviewerUserProfile className={styles.userProfile} />
      </div>
    </NavigationBar>
  );
};
